import Vue    from 'vue'
import Router from 'vue-router'
import Home   from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/inserat/uebersicht/1',
      name: 'home',
      component: Home,

      children: [
        {
          path: '/konto/',
          name: 'konto',
          component:  () => import('./views/konto/Main'),
          children: [
            {
              path: 'adresse',
              name: 'konto-adresse',
              component: () => import('./views/konto/Adresse')
            },
            {
              path: 'impressum',
              name: 'konto-impressum',
              component: () => import('./views/konto/Impressum')
            },
            {
              path: 'zugang',
              name: 'konto-zugang',
              component: () => import('./views/konto/Zugang')
            },
            {
              path: 'vertraege',
              name: 'konto-vertraege',
              component: () => import('./views/konto/Vertraege')
            },
            {
              path: 'rechnungen',
              name: 'konto-rechnungen',
              component: () => import('./views/konto/Rechnungen')
            },
            {
              path: 'zahlungsdaten',
              name: 'konto-zahlungsdaten',
              component: () => import('./views/konto/Zahlungsdaten')
            },
          ]
        },
        {
          path: '/inserat/',
          name: 'inserat',
          component:  () => import('./views/inserat/Main'),
          children: [
            {
              path: 'uebersicht/:page',
              name: 'inserat-uebersicht',
              component: () => import('./views/inserat/Uebersicht'),
              props: true
            },
            {
              path: 'bearbeiten/:id',
              name: 'inserat-edit',
              component: () => import('./views/inserat/Edit'),
              props: true
            },
          ]
        },
        {
          path: '/kontakt/anfrage',
          name: 'kontakt-anfrage',
          component: () => import('./views/kontakt/KontaktAnfrage.vue')
        },
        {
          path: '/anfragen/einsehen/:page',
          name: 'anfragen-einsehen',
          component: () => import('./views/query/Query.vue'),
          props: true
        },
        {
          path: '/bewertungen/einsehen',
          name: 'bewertung-einsehen',
          component: () => import('./views/assessment/Assessment.vue'),
        },
        {
          path: '/umsatz-steigern/',
          name: 'umsatz',
          component: () => import('./views/umsatz/Main'),
          children: [
            {
              path: 'zusatzleistung',
              name: 'umsatz-zusatzleistung',
              component: () => import('./views/umsatz/Zusatzleistung')
            },
            {
              path: 'banner',
              name: 'umsatz-banner',
              component: () => import('./views/umsatz/Banner')
            }
          ]
        }
      ]
    },
    { path: '/inserieren', redirect: '/inserat/erstellen' },
    {
      path: '/inserat/erstellen',
      name: 'inserat-create',
      component: () => import('./views/inserat/Create.vue')
    },
    {
      path: '/inserat/buchungsstrecke/:object_id?/',
      name: 'inserat-booking',
      component: () => import('./views/inserat/BookingProcess.vue'),
      props: true
    },
    {
      path: '/paket/upgrade/',
      name: 'packet-upgrade',
      component: () => import('./views/inserat/PacketUpgrade.vue'),
      props: true
    },
    {
      path: '/rechnung/bezahlen/:invoice_id',
      name: 'invoice-payment',
      component: () => import('./views/Invoice/PayInvoice.vue'),
      props: true
    },
    {
      path: '/rechnung/bezahlt/:invoice_id',
      name: 'invoice-payment-submit',
      component: () => import('./views/Invoice/PayInvoice_submit.vue'),
      props: true
    },
    {
      path: '/payment/success',
      name: 'payment-success',
      component: () => import('./components/payment/PaymentSucceed.vue')
    },
    {
      path: '/payment/cancel',
      name: 'payment-cancel',
      component: () => import('./components/payment/PaymentCanceled.vue')
    },
    {
      path: '/payment/failure',
      name: 'payment-failure',
      component: () => import('./components/payment/PaymentFailed.vue')
    },
    {
      path: '/statistik/:page?',
      name: 'inserat-statistik',
      component: () => import('./views/inserat/Statistik'),
      props: true
    },
    {
      path: '/logout',
      name: 'Logout',
      component: () => import('./views/konto/Logout'),
      props: true
    },
    {
      path: '/preiserhoehung',
      name: 'Preiserhoehung',
      component: () => import('./components/payment/Preiserhoehung.vue'),
    },
    {
      path: '*',
      name: 'Error 404',
      component: () => import('./views/NotFound'),
      props: true
    },
  ]
})
